import { Loader2 } from 'lucide-react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';

export function ProtectedRoute() {
  const { identity, isAuthInitialized, isAuthenticating } = useAppSelector(
    (state) => state.auth,
  );
  const location = useLocation();

  if (!isAuthInitialized || isAuthenticating) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAF8F5]">
        <div className="flex flex-col items-center gap-3 text-[#78665A]">
          <Loader2 className="h-8 w-8 animate-spin" />
          <span className="text-sm">Loading…</span>
        </div>
      </div>
    );
  }

  if (!identity) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!identity.emailVerified) {
    return <Navigate to="/verify-email" replace />;
  }

  return <Outlet />;
}
